import React from "react";
import clsx from "clsx";

/**
 * Skeleton - simple animated placeholder block.
 * Use width/height via className utilities (w-*, h-*) or style prop.
 */
const Skeleton = ({ className = "", ...props }) => {
  return (
    <div
      className={clsx(
        "animate-pulse bg-gray-700/30 rounded",
        className
      )}
      {...props}
    />
  );
};

export default Skeleton;